<template>   
<div class="add-class">     
<el-dialog       :visible.sync="dialogVisible"       custom-class=" public-dialog-class title-distance"       width="720px"       :close-on-click-modal="false"       :close-on-press-escape="false"       :show-close="true"       @close="cancel()"     >       
<div slot="title" class="title">         
<div class="idea-title">           <i class="iconfont icon-note" />           {{ isEdit ? "编辑班级" : "新建班级" }}         
</div>       
</div>       
<div class="dialog-header">         <img src="@/assets/images/my/dot.svg" alt="" />       
</div>        
<div class="dialog-form">         
<el-form             :model="ruleForm"             :rules="rules"             ref="ruleForm"             :validate-on-rule-change="false"             label-width="180px"             class="demo-ruleForm"         >           
<el-alert               v-if="Object.keys(errMessage).length && !errMessage.tag"               type="warning"               :closable="false"               show-icon>             <template slot="title">               
<el-row type="flex" justify="space-between" align="middle">                 <span>{{ errMessage.msg }}</span>                 
<el-button autoId="btn_$refs.sampleApply.applyCheck" v-if="errMessage.hasOwnProperty('goApply')" type="text" @click="$refs.sampleApply.applyCheck()">教师试用 
</el-button>               
</el-row>             </template>           
</el-alert>           
<el-form-item label="教材" prop="bookId">             
<el-select autoId="select_ruleForm_bookId" popper-class="book-select" :disabled="isEdit" v-model="ruleForm.bookId" filterable class="wd320" size="small" placeholder="请选择" @change="handleChange">                
<el-option v-for="item in bookOptions" :key="item.bookId" :label="item.bookName" :value="item.bookId"> 
</el-option>             
</el-select>           
</el-form-item>           
<el-form-item label="班级名称" prop="name">             
<el-input autoId="input_ruleForm_name"                 v-model="ruleForm.name"                 placeholder="请输入"                 size="small"                 maxlength="50"                 class="wd320"             > 
</el-input>           
</el-form-item>           
<el-form-item label="班级码" prop="code">             
<el-input autoId="input_ruleForm_code"                 v-model="ruleForm.code"                 disabled                 placeholder="自动生成"                 size="small"                 class="wd180"             > 
</el-input>           
</el-form-item>           
<el-form-item label="班级码有效期" prop="time">             
<el-date-picker autoId="date_ruleForm_time"                 :key="dialogVisible"                 v-model="ruleForm.time"                 value-format="yyyy-MM-dd HH:mm"                 format="yyyy-MM-dd HH:mm"                 size="small"                 class="wd320"                 type="datetimerange"                 range-separator="~"                 :default-time="defaultTime()"                 :picker-options="options"                 start-placeholder="开始日期"                 end-placeholder="结束日期"             >              
</el-date-picker>           
</el-form-item>           
<el-form-item label="是否需要教师审核" prop="isReview">             
<el-radio-group autoId="radio_group_ruleForm_isReview" v-model="ruleForm.isReview" class="wd320">                
<el-radio autoId="radio_37" label="0"               >是 <span class="form-font">(仅班级公开)</span> 
</el-radio               >               
<el-radio autoId="radio_39" label="1"               >否 <span class="form-font">(学生直接加入班级)</span> 
</el-radio               >             
</el-radio-group>           
</el-form-item>           
<el-form-item label="备注" prop="remark">             
<el-input autoId="input_ruleForm_remark"                 type="textarea"                 v-model="ruleForm.remark"                 placeholder="请输入"                 class="wd320"                 maxlength="500"                 show-word-limit             > 
</el-input>           
</el-form-item>         
</el-form>       
</div>       <template #footer>       <span class="dialog-footer">         
<el-button autoId="btn_cancel" @click="cancel">取 消 
</el-button>         
<el-button autoId="btn_confirm" type="primary" @click="confirm">确 定 
</el-button>       </span>       </template>     
</el-dialog>      
<el-dialog         custom-class="class-success-dialog"         :visible.sync="dialogVisible1"         width="360px">       
<div class="add-class-success">         <svg-icon icon-class="chenggong"></svg-icon>         
<div class="success-msg">{{ successMsg.msg }}
</div>         
<div v-if="successMsg.data" class="tip">{{ successMsg.data }}
</div>         
<el-button autoId="btn_dialogVisible1 " type="primary" size="small" @click="dialogVisible1 = false">好的 
</el-button>       
</div>     
</el-dialog>      <SampleBookApply ref="sampleApply" :detail="detail" :bookId="bookId" :reApplyVal="false" @refreshBook="handleChange"></SampleBookApply>   
</div> </template>

<script>
import { getAllBooks, isOwnBook2, saveClass, updateClass, getBookDetail } from "@/api/my/my.js";
import SampleBookApply from '@/views/my/sampleBook/components/sampleBookApply.vue'

/** 新建班级 */
export default {
  components: {
    SampleBookApply
  },
  data() {
    var checkTime = (rule, value, callback) => {
      if (!value|| value?.length == 0) {
        callback(new Error("请选择班级码有效期"));
      } else {
        callback();
      }
    };
    return {
      /** 是否编辑 */
      isEdit: false,
      dialogVisible: false,
      dialogVisible1: false,
      form: {},
      errMessage: {},
      bookOptions: [],
      detail: {},
      bookId: '',
      successMsg: {},
      ruleForm: {
        bookId: '',
        name: "",
        code: "",
        time: [],
        isReview: "",
        remark: "",
      },
      options: {
        disabledDate: (time) => {
          return time < new Date().getTime() - 3600 * 24 * 1000;
        },
      },
      rules: {
        bookId: [
          { required: true, message: '请选择教材', trigger: 'change' }
        ],
        name: [
          { required: true, tigger: ["blur", "change"], message: "请输入班级" },
        ],
        code: [
          {
            required: false,
            tigger: ["blur", "change"],
            message: "请输入班级码",
          },
        ],
        time: [
          {
            type: "array",
            required: true,
            validator: checkTime,
            tigger: ["blur", "change"],
          },
        ],
        isReview: [
          {
            required: true,
            tigger: ["blur", "change"],
            message: "请选择是否需要教师审核",
          },
        ],
      },
    };
  },
  created() {
    this.form = Object.assign({}, this.ruleForm);
    console.log('created--->',this.form)
    this.getBooksList()
  },
  methods: {
    /**
     * 查询教材状态
     * @returns {Promise<void>}
     */
    async handleChange() {
      try {
        this.errMessage = await isOwnBook2({
          bookId: this.ruleForm.bookId
        })
        if (Object.prototype.hasOwnProperty.call(this.errMessage, 'goApply') && !this.errMessage.tag) {
          // 获取书籍信息
          this.getBookDetail()
        }
      } catch (e) {
        console.log(e)
      }
    },

    /**
     * 获取书籍信息
     * @returns {Promise<void>}
     */
    async getBookDetail() {
      try {
        const { data } = await getBookDetail(this.ruleForm.bookId)
        this.detail.cover = data.cover
        this.detail.title = data.title
        this.detail.editorBookId = data.editorBookId
        this.bookId = data.id
      } catch (e) {
        console.log(e)
      }
    },

    defaultTime() {
      const now = new Date()
      const currentTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:00`
      return [currentTime, '23:59:00']
    },
    open(item, isEdit, bookId) {
      this.dialogVisible = true;
      this.isEdit = isEdit;
      // 可能会出现书本下架找不到id的情况
      this.ruleForm.bookId = this.bookOptions.find(it => it.bookId === bookId)?.bookId || ''
      if (item) {
        this.$nextTick(() => {
          this.ruleForm = Object.assign(this.ruleForm, item);
          this.ruleForm.time = [item.startTime, item.endTime];
        });
      } else {
        if(this.ruleForm.bookId) this.handleChange()
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.errMessage = {}
      this.ruleForm = Object.assign({}, this.form);
      this.resetForm("ruleForm");
    },
    confirm() {
      if (Object.keys(this.errMessage).length && !this.errMessage.tag) return this.$message.error(this.errMessage.msg)
      this.$refs.ruleForm.validate((result) => {
        if (result) {
          const params = Object.assign({}, this.ruleForm);
          params.startTime = params.time && params.time[0];
          params.endTime = params.time && params.time[1];
          if (this.isEdit) {
            updateClass(params).then((res) => {
              if (res.code === 200) {
                // this.$message.success("修改成功");
                this.dialogVisible1 = true
                this.successMsg.msg = '修改成功'
                this.successMsg.data = res.data
                this.$emit("success", this.ruleForm.bookId);
                this.cancel();
              }
            });
          } else {
            saveClass(params).then((res) => {
              if (res.code === 200) {
                // this.$message.success("新建成功");
                this.dialogVisible1 = true
                this.successMsg.msg = '创建成功'
                this.successMsg.data = res.data
                this.$emit("success", this.ruleForm.bookId);
                this.cancel();
              }
            });
          }
        }
      });
    },

    /**
     * 获取书籍列表
     */
    getBooksList() {
      getAllBooks().then(res => {
        this.bookOptions = res.data || []
      })
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .class-success-dialog {
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    .add-class-success {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 63px 0;

      .svg-icon {
        width: 40px;
        height: 40px;
        margin-bottom: 8px;
      }

      .success-msg {
        font-weight: 500;
        font-size: 16px;
        color: #70BD0F;
      }

      .tip {
        font-size: 12px;
        color: #B9BECC;
        margin-top: 8px;
      }

      .el-button {
        margin-top: 10px;
        padding-left: 24px;
        padding-right: 24px;
        font-size: 14px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.demo-ruleForm {
  .el-alert {
    margin-bottom: 22px;
    border: 1px solid #FAA501;

    ::v-deep .el-alert__content {
      flex: 1;

      .el-button {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
}

.dialog-header {
  display: flex;
  opacity: 0;
  padding-right: 12px;
  justify-content: flex-end;
  // height: 24px;
  height: 12px;
  border-bottom: 1px solid var(--lineColor);
  img {
    width: 40px;
  }
}
.dialog-title {
  padding: 12px 36px;
  color: #3e4d71;
  font-size: 18px;
  font-weight: 500;
  .icon-bg {
    display: inline-block;
    margin-right: 4px;
    width: 32px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    background: #eef3ff;
    border-radius: 50%;
  }
  i {
    font-size: 16px;
    color: #5584fb;
  }
}
.dialog-form {
  padding: 28px 36px 38px;
  .form-font {
    color: #b9becc;
    font-size: 12px;
    font-weight: 400;
  }
}
.wd320 {
  width: 320px;
}
.wd180 {
  width: 180px;
}
.el-form-item {
  margin-bottom: 16px;
}
:deep(.el-dialog__header) {
  padding: 0;
}
:deep(.el-dialog__body) {
  padding: 0;
}
:deep(.el-radio__inner) {
  border-radius: 2px;
}
:deep(.is-checked .el-radio__inner) {
  &::after {
    content: "";
    font-family: "element-icons" !important;
    border-radius: 0;
    color: white;
    background: none;
    left: 25%;
    top: 25%;
    font-size: 10px;
  }
}
</style>

<style>
  /* 教学空间-新建班级-教材下拉宽度 */
.book-select {
  max-width: 485px;
}
</style>
